import { LazyLoader } from '@bp/ui-components';
import { useQuery as useReactQuery } from '@tanstack/react-query';
import { graphql } from 'client/gql';
import { usePermissionChecker } from 'hooks/usePermissionChecker';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useMatches } from 'react-router-dom';
import { useQuery } from 'urql';
import { BpSubpage } from '../../../components/BpSubpage/BpSubpage';
import {
  DesktopNavigationTabs,
  type DesktopNavigationTabsType,
} from '../../../components/NavigationTabs/Desktop/DesktopNavigationTabs';
import { useAuthClaims } from '../../../hooks/useAuthClaims';
import { backendApi } from '../../../utils/backendApi';
import { showErrorToast } from '../../../utils/showErrorToast';

export const SettingsProcuratSubpage: FC = () => {
  const { t } = useTranslation();

  const perms = usePermissionChecker();

  const matches = useMatches();
  const last = [...matches].pop();

  const { data, isFetching } = useReactQuery({
    queryKey: ['procuratOrga'],
    queryFn: async () => {
      const response = await backendApi.fetch(`/procurat/organization`, {
        method: 'GET',
      });
      return await response.json();
    },
  });

  if (data?.error) {
    showErrorToast({ graphQLErrors: [], message: data.error, name: '' });
  }

  const procuratOrga = Array.isArray(data) && data?.find((o: { current: boolean }) => o.current);

  const tabs: DesktopNavigationTabsType[] = [
    {
      title: `${t('procuratImport.department.plural')}`.trim(),
      path: `/settings/procurat/`,
      active: last?.id === 'departments',
    },
    {
      title: `${t('schoolyears.title')}/${t('classes.titlePlural')}`.trim(),
      path: `classes`,
    },
    {
      title: `${t('groups.title')}`.trim(),
      path: `persongroups`,
    },
  ];

  return (
    <BpSubpage isForbidden={!perms?.canAccessProcuratImport()}>
      {isFetching ? (
        <LazyLoader embedded forceHeight='15vh' />
      ) : !data?.error && procuratOrga ? (
        <>
          <h2>{procuratOrga?.name}</h2>
        </>
      ) : (
        <>
          <h2>{t('procuratImport.notEnabledOrNoConnection')}</h2>
        </>
      )}
      {!data?.error && procuratOrga && (
        <div className='mt-8'>
          <DesktopNavigationTabs tabs={tabs} size='s' className='mb-4' />
          <Outlet />
        </div>
      )}
    </BpSubpage>
  );
};
